<div class="aw-dialog">
  <div class="aw-dialog-header">Devices that Don't Belong to a Group</div>
  <div class="aw-dialog-sub-header">Add device(s) to {{selectedGroupName}}</div>

  <div class="cb-list-container">
    <div class="cb-list-header">
      <!-- Select All -->
      <input type="checkbox" class="aw-checkbox" style="margin-right: 16px;"
        [disabled]="unassignedGroup.deviceList.length === 0"
        [checked]="isAllChecked"
        (change)="selectAllCheck(isAllChecked)"/>
      <span>{{unassignedGroup.deviceList.length}} Devices</span>
      <span *ngIf="selectedDeviceList.length > 0">| {{selectedDeviceList.length}} Selected</span>
      <!-- /.Select All -->
    </div>

    <ul class="aw-sm-list" *ngIf="unassignedGroup.deviceList.length > 0">
      <li class="aw-sm-list-item"
        [style.border-bottom]="i === deviceWithCheckList.length - 1 ? 'none' : '1px solid #DEE2E5'"
        *ngFor="let deviceWithCheck of deviceWithCheckList | objArraySort:'name'; let i = index">
        <input type="checkbox" class="aw-checkbox" style="margin-right: 16px; margin-top: 3px;"
          [checked]="deviceWithCheck.checked"
          (change)="selectDevice(deviceWithCheck)"/>
        <span style="max-width: 190px">{{deviceWithCheck.deviceName | namize}}</span>
        <span class="aw-sm-list-item-sub flex-right">{{deviceWithCheck.email}}</span>
      </li>
    </ul>
  </div>

  <div class="btn-set">
    <button class="aw-btn aw-btn-gray" (click)="onCancel()">Cancel</button>
    <button class="aw-btn aw-btn-blue" (click)="onAdd()" [disabled]="selectedDeviceList.length === 0">
      <span *ngIf="selectedDeviceList.length === 0">Add Devices</span>
      <span *ngIf="selectedDeviceList.length > 0">Add {{selectedDeviceList.length}} Devices</span>
    </button>
  </div>
</div>
